var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgRcfIconRed(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 27,
    height: 25,
    viewBox: "0 0 27 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.73246 11.5616L5.24684 14.997M5.24684 14.997L8.73296 11.0695M5.24684 14.997C4.93111 13.4665 4.88456 11.8125 5.30611 10.183C6.76102 4.5589 12.4209 1.15752 17.946 2.58683C23.4711 4.01614 26.7715 9.73549 25.3166 15.3596C23.8617 20.9836 18.2018 24.385 12.6767 22.9557C11.0759 22.5416 9.66349 21.7657 8.5051 20.7416",
    stroke: "#E60000",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13.3008 17.5573V7.96866C15.9903 7.91019 18.4459 7.55939 18.4459 10.2372C18.4459 13.1723 15.6395 12.7045 13.4177 12.763",
    stroke: "#E60000",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M16.3418 12.7046L18.7974 17.382",
    stroke: "#E60000",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRcfIconRed);
export default __webpack_public_path__ + "static/media/RCFIconRed.cc0868e8fd22defb8fbb185543e435a6.svg";
export { ForwardRef as ReactComponent };